import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { methodologySteps } from "@/mocks/site";

export default function MethodologySection() {
  return (
    <section
      id="methodology"
      aria-labelledby="methodology-heading"
      className="w-full scroll-mt-20 border-b border-background-200 bg-secondary-50"
    >
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="How We Read"
          id="methodology-heading"
          title="我们是怎样解读一件事的"
          desc="四步固定流程，每一篇解读都按这个顺序写。顺序本身就是一种态度：先有事实，再有疑问，最后才是判断。"
        />

        <div className="mt-10 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-background-300 bg-background-300 sm:grid-cols-2 lg:grid-cols-4">
          {methodologySteps.map((step, index) => (
            <Reveal key={step.index} delay={index * 70} className="h-full">
              <article className="flex h-full flex-col bg-background-50 p-6">
                <span className="font-heading text-3xl font-black text-accent-500">
                  {step.index}
                </span>
                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  {step.desc}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}